import { render, staticRenderFns } from "./StatByCity.vue?vue&type=template&id=3cf7dd5a&"
import script from "./StatByCity.vue?vue&type=script&lang=ts&"
export * from "./StatByCity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports